class FostrCarouselButton extends HTMLElement {
  constructor() {
    super();
    this.targetEl = null;
    this.infinite = null;
    this.currentIndex = 0;
    this.totalItems = 0;
    this.previousButton = null;
    this.nextButton = null;
  }

  connectedCallback() {
    this.targetEl = document.getElementById(this.dataset.targetElId);
    this.infinite = this.dataset.infinite;
    this.totalItems = this.targetEl.childElementCount;

    if (this.targetEl.children.length <= 0) {
      return;
    }

    if (this.targetEl.children[0].offsetWidth === 0) {
      this.totalItems -= this.totalItems;
    }

    this.previousButton = this.parentNode.querySelector('[data-action="previous"]');
    this.nextButton = this.parentNode.querySelector('[data-action="next"]');
    this.addEventListener('click', this.handleClick);
    this.updateButtonState();
    this.targetEl.addEventListener('scroll', this.handleScroll);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.targetEl.removeEventListener('scroll', this.handleScroll);
  }

  getCurrentIndex() {
    let elWidth = this.targetEl.children[0].offsetWidth;
    if (elWidth === 0) {
      elWidth = this.targetEl.children[1].offsetWidth;
    }

    let currentIndex = Math.round(this.targetEl.scrollLeft / elWidth);
    if (this.targetEl.children[0].offsetWidth === 0) {
      currentIndex += 1;
    }

    return currentIndex;
  }

  handleClick = (e) => {
    e.preventDefault();
    const { action } = this.dataset;

    this.currentIndex = this.getCurrentIndex();

    let nextIndex;
    if (action === 'next') {
      nextIndex = this.currentIndex + 1;
      if (nextIndex >= this.targetEl.childElementCount) {
        nextIndex -= 1;
        if (this.infinite === 'true') {
          this.targetEl.appendChild(this.targetEl.children[0]);
        }
      }
    } else if (action === 'previous') {
      nextIndex = this.currentIndex - 1;
      if (nextIndex < 0) {
        nextIndex = 0;
        if (this.infinite === 'true') {
          this.targetEl.prepend(this.targetEl.children[this.targetEl.childElementCount - 1]);
        }
      }
    }

    const nextItem = document.getElementById(this.dataset.targetElId).children[nextIndex];
    document.getElementById(this.dataset.targetElId).scrollTo({
      left: nextItem.offsetLeft,
      behavior: 'smooth',
    });

    this.currentIndex = nextIndex;
  }

  handleScroll = () => {
    setTimeout(() => {
      this.currentIndex = this.getCurrentIndex();
      this.updateButtonState();
    }, 250);
  }

  updateButtonState() {
    let isPreviousDisabled = this.currentIndex === 0;

    if (this.targetEl.children[0].offsetWidth === 0 && this.currentIndex === 1) {
      isPreviousDisabled = true;
    }

    let isNextDisabled = (this.targetEl.scrollLeft + this.targetEl.offsetWidth >= this.targetEl.scrollWidth - 100);

    this.previousButton.setAttribute('aria-disabled', isPreviousDisabled);
    this.nextButton.setAttribute('aria-disabled', isNextDisabled);

    if (isPreviousDisabled) {
      this.previousButton.classList.add('is-disabled');
    } else {
      this.previousButton.classList.remove('is-disabled');
    }

    if (isNextDisabled) {
      this.nextButton.classList.add('is-disabled');
    } else {
      this.nextButton.classList.remove('is-disabled');
    }
  }
}

customElements.define('fostr-carousel-button', FostrCarouselButton);
